import React, { useEffect } from 'react';
import Header from '../../components/common/global-top-bar';
import RightArrow from '../../assets/images/left-arrow-symbol.svg';
import { useDispatch, connect } from 'react-redux';
import Spinner from '../../components/common/spinner';
import { fetchTiersListRequest } from './redux-templates/actions';
import { useHistory } from 'react-router';
import { ROUTE_PATH } from '../../routes/paths';

type props = {
  tiersList: any;
  pending: any;
};

const tierStatus = {
  unpublished: 'Unpublished',
  published: 'Published',
};

const TierListing: React.FunctionComponent<props> = (props): JSX.Element => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(fetchTiersListRequest({ all_tier_versions: true, include_unpublished: true }));
  }, []);

  return (
    <div>
      <Header heading={'Tiers'} />
      <div className="bg-gray-background-light flex h-10 items-center justify-end px-7">
        <button
          className="h-6 w-20 rounded-full bg-white px-2 text-center text-sm text-black"
          onClick={() => {
            history.push(`${ROUTE_PATH.TIER_DETAILS}/?tier-id=new`);
          }}
        >
          ADD +
        </button>
      </div>

      <div className="max-window-height overflow-y-auto pb-10">
        <div className="w-full px-3">
          {props.pending ? (
            <Spinner />
          ) : (
            <table className="table-row-format relative w-full table-fixed border-collapse">
              <thead className="h-full bg-white">
                <tr className="w-full px-7 pt-5 text-left">
                  <th className="sticky top-0 mb-4 h-full w-1/12 bg-white px-2 py-2 pl-2">
                    <p className="px-2"> Name</p>
                  </th>
                  <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">
                    <p className="ml-4 px-2"> Status </p>
                  </th>
                  <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">Call Earnings</th>
                  <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">Office Hours Cap</th>
                  <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">
                    <p className="ml-1">Office Hour Rate</p>
                  </th>
                  <th className="sticky top-0 mb-4 h-full w-3/12 bg-white px-2 py-2">
                    <p className="ml-4">Minimum Office Hours</p>
                  </th>
                  <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">Call Bonus</th>
                  <th className="z-100 sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">Is Default?</th>
                </tr>
              </thead>
              <tbody>
                <tr className="h-2"></tr>
                {props.tiersList?.length > 0 &&
                  props.tiersList.map((item: any, index: any) => {
                    return (
                      <tr
                        className="text-gray-dark h-12 space-y-6 rounded border-4 border-y border-white bg-gray-200 text-left"
                        onClick={() => {
                          history.push(`${ROUTE_PATH.TIER_DETAILS}/?tier-id=${item.id}`);
                        }}
                        role="button"
                      >
                        <td className="text-gray-dark w-2/12 px-2 py-1 pl-2 font-bold">{item.name}</td>
                        <td className="w-1/12 px-2 py-1">
                          <p className="ml-4">
                            {/* @ts-ignore */}
                            {tierStatus[item.status]}
                          </p>
                        </td>
                        <td className="w-2/12 px-2 py-1">{` $${(item.call_earnings / 100).toFixed(2)}`}</td>
                        <td className="w-2/12 px-2 py-1">{`${item.paid_office_hours_cap}`}</td>
                        <td className="w-2/12 px-2 py-1">
                          <p className="ml-2">{`$${(item.office_hour_rate / 100).toFixed(2)}`}</p>
                        </td>
                        <td className="w-3/12 px-2 py-1">
                          <p className="ml-4">{`${item.minimum_office_hours}`}</p>
                        </td>
                        <td className="w-2/12 px-2 py-1">{`$${(item.call_bonus / 100).toFixed(2)}`}</td>
                        <td className="w-2/12 px-2 py-1">
                          <div className="flex items-center justify-between">
                            <div> {`${item.is_default ? 'Yes' : 'No'}`}</div>
                            <button className="blue-primary h-8 w-8 rotate-180 transform rounded-full">
                              <img className="h-8 w-8" src={RightArrow} alt="left Arrow"></img>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    tiersList: state.tiers.TiersList?.data || null,
    pending: state.tiers?.pending || null,
  };
};

export default connect(mapStateToProps)(TierListing);
